import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { ChatMessage as ChatMessageType } from '../../services/aiService';

interface Props {
  message: ChatMessageType;
}

export default function ChatMessage({ message }: Props): JSX.Element {
  const isUser = message.role === 'user';

  return (
    <div className={`flex w-full ${isUser ? 'justify-end' : 'justify-start'}`}>
      <div
        className={`max-w-[80%] rounded-2xl px-4 py-2 text-sm leading-relaxed ${
          isUser
            ? 'rounded-tr-sm bg-primary-900 text-white'
            : 'rounded-tl-sm bg-secondary-200 text-primary-900'
        }`}>
        {isUser ? (
          message.content
        ) : (
          <div className="space-y-2 break-words [&_a]:font-medium [&_a]:underline [&_code]:rounded [&_code]:bg-primary-900/10 [&_code]:px-1 [&_code]:py-0.5 [&_ol]:list-decimal [&_ol]:pl-5 [&_pre]:overflow-x-auto [&_pre]:rounded-lg [&_pre]:bg-primary-900 [&_pre]:p-3 [&_pre]:text-secondary-50 [&_ul]:list-disc [&_ul]:pl-5">
            <ReactMarkdown remarkPlugins={[remarkGfm]}>{message.content}</ReactMarkdown>
          </div>
        )}
      </div>
    </div>
  );
}
